<template>
  <div v-if="selectedAssignment">
    <!-- Show Selected Assignment card if an assignment is selected -->
    <SelectedAssignment
      :assignment="selectedAssignmentStore"
      @change="openAssignmentDialog"
      :showCollapseIcon="false"
      :showChangeButton="true"
    />
  </div>
  <div v-if="!selectedAssignmentStore" class="assignment-bar mb-5 border-all-dashed">
    <span>{{ assignment ? assignment : "No Assignment Selected" }}</span>
    <button class="select-assignment-button" @click="openAssignmentDialog">
      Select Assignment
    </button>
  </div>
  <!-- Show Selected Assignment card if an assignment is selected -->

  <AssignmentDialog
    :visible="showDialog"
    @close="showDialog = false"
    @selectAssignment="handleAssignmentSelection"
    @submit="onAssignmentSelected"
    @refresh="fetchAssignments"
    :loadAssignments="true"
  />
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import SelectedAssignment from "./SelectedAssignment.vue";
import AssignmentDialog from "./AssignmentDialog.vue";

export default {
  name: "AssignmentBar",
  components: { AssignmentDialog, SelectedAssignment },
  data() {
    return {
      showDialog: false,
      assignments: [],
      selectedAssignment: null, // Tracks the selected assignment
    };
  },
  computed: {
    ...mapGetters({
      assignmentChecklist: "assignments/assignmentChecklist", // Use the getter for assignment
    }),
    ...mapState({
      selectedAssignmentStore: state => state.assignments.selectedAssignment, // Get the selected assignment from Vuex
    }),
  },

  methods: {
    ...mapActions({
      add: "notification/add",
      fetchAssignments: "assignments/fetchAssignments",
      setSelectedAssignment: "assignments/selectAssignment",
      setAssignmentChecklist: "assignments/setAssignmentChecklist",
      fetchAssignmentChecklist: "assignments/fetchAssignmentChecklist",
    }),
    onAssignmentSelected(assignment) {
      alert("Selected: " + assignment.code + " - " + assignment.client);
    },
    openAssignmentDialog() {
      this.closeAssignmentDialog(); // Close any existing dialog
      this.showDialog = true; // Open the dialog
    },
    closeAssignmentDialog() {
      this.showDialog = false; // Close the dialog
    },
    async handleAssignmentSelection(assignment) {
      // Update the selected assignment when a new one is chosen
      this.selectedAssignment = assignment;
      this.setSelectedAssignment(assignment); // Update Vuex store with the selected assignment

      this.closeAssignmentDialog(); // Close the dialog after selection
    },
  },
  async mounted() {
    // await this.fetchAssignments();
  },
};
</script>

<style scoped>
@media (max-width: 320px) {
  .select-assignment-button {
    padding: 4px 10px;
    font-size: 12px!important;
  }
}
@media (min-width: 321px) and (max-width: 480px) {
  .select-assignment-button {
    padding: 4px 10px;
    font-size: 12px;
  }
}
.select-assignment-button {
  padding: 4px 5px;
  width: 150px;
  background-color: #003F2D;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  line-height: 16px;
  font-family: Calibre-R;
  min-height: 36px;
font-weight: 200;
font-size: 16px;
line-height: 16px;
letter-spacing: 0%;
text-align: center;
vertical-align: middle;
  font-style: normal;
}

.select-assignment-button:hover {
  background-color: #005a40;
}

</style>
